import {createFileRoute} from '@tanstack/react-router'

import PipedriveScreen from '@protected/pipedrive'

export const Route = createFileRoute('/_protected/pipedrive')({component: PipedriveScreen})
